import Lottie from "lottie-react";
import React, {useState, useEffect, } from "react"
import NewsData from '../Data/News'
import MemegorWhite from "../lottie-loop/mg-icon-loop-white.json";


function News(props) {
    const [offsetY, setOffsetY] = useState(0);
    const handleScroll = () => setOffsetY(window.pageYOffset);

    useEffect(() => {

        window.addEventListener("scroll", handleScroll);
        return() => window.removeEventListener('scroll', handleScroll);

    }, [])
    return (
        <>
         {NewsData.map((News) => (
        <div className="py-32 mt-24">
            <div className="flex flex-row justify-between w-full gap-20 relative">
                <div>
                    <div className="md:text-9xl text-5xl font-mono py-10 max-w-2xl">{News.title}</div>
                    <div className="md:text-xl text-xl font-mono lg:px-0  lg:max-w-2xl">{News.desc}</div>
                </div>
                <a href="/about">
                <div className=" hover:scale-125 duration-500">
                    <div style={{
                                    transform: `translateY(${offsetY * 0.05}px)`
                                }}  
                        className=" bg-red-600 rounded-full xl:w-96 xl:h-96 lg:w-72 lg:h-72 md:w-64 md:h-64 w-48 h-48 absolute lg:right-16 md:right-10 right-0">
                        <Lottie animationData={MemegorWhite} loop="true" className="w-full h-full object-cover px-5 py-5 " />
                    </div>
                </div>
                </a>
            </div>
        </div>
         ))}
         <a href="/find" className="">
         <div className="relative w-full bg-red-500 h-full rounded-xl hover:scale-90 hover:shadow-xl duration-500">
            <div className="relative px-8 py-10 w-full h-full z-20 grid lg:grid-cols-2 grid-cols-1 gap-10">
                <div>
                    <p className="font-mono font-bold lg:text-6xl md:text-5xl text-4xl max-w-5xl leading-tight text-white">Indonesia Convention Exhibition (ICE) </p>
                    <div className="py-8">
                        <span className="p-4 bg-white rounded-full xl:text-3xl text-xl font-mono text-red-500">25 September 2022</span>                    
                    </div>
                </div>
                <div className="w-full h-full mx-auto flex lg:flex-row-reverse">
                    <p className="text-white font-mono font-bold text-8xl">B-28B</p>
                </div>
            </div>
            <img alt="" src="https://destinasian.co.id/id/wp/wp-content/uploads/ICE-BSD-01.jpg" className="w-full z-10 h-full object-cover opacity-30 absolute inset-0 rounded-xl " />
         </div>
         </a>
        </>
    )
}

export default News;